import update from 'immutability-helper';
import * as types from './types';

// store for dimension api state
// { dimensionKey: dimensionData }

const initialState = {};
const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SETUP_DIMENSION] = (state, action) => {
  const { dimension, dimensionStore } = action;
  return update(state, {
    [dimension]: { $set: dimensionStore },
  });
}

switchMap[types.UNSET_DIMENSION] = (state, action) => {
  return update(state, {
    $unset: [action.dimension],
  });
}

switchMap[types.SET_RESPONSE] = (state, action) => {
  const { dimension, response, errorMsg } = action;
  return update(state, {
    [dimension]: {
      $merge: {
        response,
        isFetching: false,
        errorCode: 0,
        errorMsg,
        invalid: false,
      },
    },
  });
}
switchMap[types.SET_BENCHMARK_RESPONSE] = (state, action) => {
  const { dimension, response, errorMsg } = action;
  return update(state, {
    [dimension]: {
      $merge: {
        response,
        isFetching: false,
        errorCode: 0,
        errorMsg,
        invalid: false,
      },
    },
  });
}

switchMap[types.SET_LOADING_STATE] = (state, action) => {
  const { dimension, loadingState } = action;
  return update(state, {
    [dimension]: {
      isFetching: { $set: loadingState },
    },
  });
}

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
